import React from 'react';

export default function OnlineMoveIn() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="svg online-move-in"
			width="21"
			height="16"
			viewBox="0 0 21 16"
		>
			<path
				d="M19.9754 1.22318V12.4306C19.9754 12.9049 19.6042 13.2793 19.1338 13.2793H1.23759C0.767288 13.2793 0.395996 12.9049 0.395996 12.4306V1.22318C0.395996 0.748925 0.767288 0.374512 1.23759 0.374512H19.1338C19.6042 0.374512 19.9754 0.748925 19.9754 1.22318Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.2373 0.748827C0.972056 0.748827 0.766997 0.955609 0.766997 1.22308V12.4305C0.766997 12.698 0.972056 12.9048 1.2373 12.9048H19.1335C19.3988 12.9048 19.6039 12.698 19.6039 12.4305V1.22308C19.6039 0.955602 19.3988 0.748827 19.1335 0.748827H1.2373ZM0.0244141 1.22308C0.0244141 0.542044 0.561938 0 1.2373 0H19.1335C19.8089 0 20.3464 0.542052 20.3464 1.22308V12.4305C20.3464 13.1116 19.8089 13.6536 19.1335 13.6536H1.2373C0.561938 13.6536 0.0244141 13.1116 0.0244141 12.4305V1.22308Z"
				fill="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.2029 13.2792L12.3514 14.4523L12.4999 15.6255H7.72266L8.01969 13.2792H12.2029Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.65159 13.2319C7.67525 13.045 7.83301 12.9049 8.01989 12.9049H12.2031C12.39 12.9049 12.5477 13.045 12.5714 13.2319L12.8684 15.5782C12.882 15.6849 12.8493 15.7923 12.7788 15.8731C12.7083 15.9538 12.6068 16.0001 12.5001 16.0001H7.72286C7.61619 16.0001 7.51467 15.9538 7.44419 15.8731C7.3737 15.7923 7.34105 15.6849 7.35455 15.5782L7.65159 13.2319ZM8.3468 13.6537L8.14456 15.2512H12.0784L11.8762 13.6537H8.3468Z"
				fill="black"
			/>
			<path
				d="M19.9753 1.22318V10.4337H0.371094V1.22318C0.371094 0.748925 0.742385 0.374512 1.21269 0.374512H19.1089C19.604 0.374512 19.9753 0.748925 19.9753 1.22318Z"
				fill="#FFCB03"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.21289 0.748827C0.947642 0.748827 0.742583 0.955609 0.742583 1.22308V10.0592H19.6042V1.22308C19.6042 0.962704 19.4062 0.748827 19.1091 0.748827H1.21289ZM0 1.22308C0 0.542044 0.537524 0 1.21289 0H19.1091C19.8021 0 20.3468 0.534949 20.3468 1.22308V10.4337C20.3468 10.6404 20.1805 10.8081 19.9755 10.8081H0.371292C0.166233 10.8081 0 10.6404 0 10.4337V1.22308Z"
				fill="black"
			/>
			<path
				d="M12.401 3.76916L11.3366 4.84248L15 8.53669C15.4208 8.96102 15.4208 9.63497 15 10.0343L13.2673 11.7816C12.8465 12.2059 12.1782 12.2059 11.7822 11.7816L8.11875 8.08739L7.02963 9.18567C6.55933 9.65993 5.79199 9.31048 5.79199 8.66149V3.7442C5.79199 3.07026 6.33655 2.52112 7.00488 2.52112H11.8812C12.5495 2.52112 12.8713 3.29491 12.401 3.76916Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.00508 2.89543C6.54181 2.89543 6.16348 3.27694 6.16348 3.7441V8.6614C6.16348 8.99666 6.54472 9.14527 6.76729 8.92083L7.85641 7.82255C7.92604 7.75233 8.02048 7.71288 8.11895 7.71288C8.21742 7.71288 8.31186 7.75233 8.38149 7.82255L12.0449 11.5168C12.0476 11.5194 12.0502 11.5221 12.0527 11.5249C12.2979 11.7876 12.7246 11.7995 13.005 11.5168L14.7377 9.7695C14.7403 9.76682 14.743 9.76419 14.7457 9.7616C15.0062 9.51438 15.018 9.08405 14.7377 8.80134L11.0743 5.10713C11.0046 5.03692 10.9655 4.94168 10.9655 4.84238C10.9655 4.74308 11.0046 4.64785 11.0743 4.57763L12.1386 3.50431C12.3707 3.27027 12.225 2.89543 11.8814 2.89543H7.00508ZM5.4209 3.7441C5.4209 2.86338 6.13169 2.14661 7.00508 2.14661H11.8814C12.8744 2.14661 13.3722 3.31934 12.6637 4.03381L11.8619 4.84238L15.2628 8.27184C15.8226 8.83637 15.8357 9.75073 15.2591 10.3027L13.5301 12.0463C12.9702 12.6108 12.0635 12.6241 11.5161 12.0425L8.11895 8.6168L7.29237 9.45033C6.57434 10.1744 5.4209 9.6241 5.4209 8.6614V3.7441Z"
				fill="black"
			/>
			<path
				opacity="0.16"
				d="M12.3513 14.4523H7.87109L8.01961 13.3041H12.2028L12.3513 14.4523Z"
				fill="black"
			/>
		</svg>
	);
}

